module.exports = __webpack_public_path__ + "assets/7d6fb1c69390b3bb8ee5f9f7010c5a4d.png";